import { Button } from 'antd';
import './style.css';

interface BulkApproveButtonProps {
  show: boolean;
  onClick: () => Promise<void>;
  disabled: boolean;
}

export const BulkApproveButton = ({ show, ...rest }: BulkApproveButtonProps) => {
  return show ? (
    <div className='bulk-approve-button-container'>
      <Button size='small' {...rest}>
        Bulk approve
      </Button>
    </div>
  ) : null;
};
